import { EventsTable, RequestsTable, Section } from '@/components/molecules'
import { useHistory } from '@/hooks'
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import { useState } from 'react'

export const History = ({ subId, isLoading }) => {
  const [startFetch, setStartFetch] = useState(false)
  const { requests, isLoadingRequests, events, isLoadingEvents } = useHistory({
    subId,
  })

  return (
    <Section
      title={'History'}
      isLoading={isLoading}
      action={{
        text: 'Fetch History',
        action: () => setStartFetch(true),
        isDisabled: startFetch,
      }}
      mb={0}
    >
      {subId && startFetch && (
        <Tabs colorScheme={'purple'} alignSelf={'stretch'}>
          <TabList>
            <Tab>Requests</Tab>
            <Tab>Events</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <RequestsTable
                requests={requests}
                isLoading={isLoadingRequests || isLoading}
              />
            </TabPanel>
            <TabPanel>
              <EventsTable
                events={events}
                isLoading={isLoadingEvents || isLoading}
              />
            </TabPanel>
          </TabPanels>
        </Tabs>
      )}
    </Section>
  )
}
